// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gb-a";
export var fulfillmentFormRail = "_gb-9";
export var headerTitleRow = "_gb-c";
export var orderDetailsWrapper = "_gb-7";
export var orderLinkTrigger = "_gb-2";
export var paymentInformationGrid = "_gb-h";
export var paymentSummaryColumn = "_gb-i";
export var shipmentContainer = "_gb-b";
export var shipmentDetailsMainPane = "_gb-8";
export var shipmentNavigationCard = "_gb-5";
export var shipmentNavigationRail = "_gb-3";
export var shipmentNavigationRailHeader = "_gb-4";
export var shipmentSummaryFact = "_gb-e";
export var shipmentSummaryGrid = "_gb-d";
export var shipmentSummaryMetadataRow = "_gb-f";
export var shipmentSummaryTags = "_gb-g";
export var shipmentWorkspace = "_gb-0";
export var shipmentWorkspaceContent = "_gb-6";
export var shipmentWorkspaceHeader = "_gb-1";